export default __webpack_public_path__ + "imgs/fv-img-sp.png";